import { render, staticRenderFns } from "./MigrationMessagesCard.vue?vue&type=template&id=ca8a7560&scoped=true&"
import script from "./MigrationMessagesCard.vue?vue&type=script&lang=js&"
export * from "./MigrationMessagesCard.vue?vue&type=script&lang=js&"
import style0 from "./MigrationMessagesCard.vue?vue&type=style&index=0&id=ca8a7560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8a7560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca8a7560')) {
      api.createRecord('ca8a7560', component.options)
    } else {
      api.reload('ca8a7560', component.options)
    }
    module.hot.accept("./MigrationMessagesCard.vue?vue&type=template&id=ca8a7560&scoped=true&", function () {
      api.rerender('ca8a7560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/MigrationMessagesCard.vue"
export default component.exports